import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PlusOutlined, EditOutlined,ReloadOutlined, ShoppingCartOutlined, DeleteOutlined, MoreOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { getProducts, postProducts, updateProduct, deleteProducto } from '../../../store/MSCommerce/Productos/thunks';
import { deleteImagen } from '../../../store/MSCommerce/Imagenes/thunks';
import { GetAllCategorys } from '../../../store/MSCommerce/Categories/thunks';
import type { ProductosResponse, ProductosRequest, UpdateProductsRequest } from '../../../store/MSCommerce/Productos/types';
import type { CategoryResponse } from '../../../store/MSCommerce/Categories/types';
import { AppState } from '../../../store';
import { isAdmin } from '../../../Services/auth';
// Agrega esta línea a los imports existentes
import { getAllOfertasActivas } from '../../../store/MSCommerce/Ofertas/thunks';
import { getOfertaParaProducto, calcularPrecioFinal } from '../../../Services/ofertaUtils';
import { addItem } from '../../../store/Carrito/actions';
import type { CarritoItem } from '../../../store/Carrito/types';

import { ImageCarousel } from './components/ImageCarousel';
import { CreateProductModal } from './components/CreateProductModal';
import { ProductDetailModal } from './components/ProductDetailModal';
import { UpdateProductModal } from './components/UpdateProductModal';

import styles from './Productos.module.scss';
import { OfertaResponse } from '../../../store/MSCommerce/Ofertas/types';
  const { Search } = Input;
const { Option } = Select;
const STOCK_BAJO_UMBRAL = 5;
const PRODUCTOS_POR_CARGA = 24;
type AvailabilityFilter = 'todos' | 'disponibles' | 'bajo' | 'agotados';
type SortOption = 'destacados' | 'precioAsc' | 'precioDesc' | 'nombre';
interface ProductosProps {
  getProducts?: (categoria?: string, nombre?: string) => void;
  postProducts?: (data: ProductosRequest) => void;
  updateProduct?: (data: UpdateProductsRequest) => void;
  deleteProducto?: (id: string) => void;
  deleteImagen?: (url: string) => void;
  GetAllCategorys?: () => void;
    getAllOfertasActivas?: () => void;
  addItem?: (item: CarritoItem) => void;
  ofertas?: OfertaResponse[];
  productos?: ProductosResponse[];
  categorias?: CategoryResponse[];
  carritoItems?: CarritoItem[];
  loading?: boolean;
}

const Productos: React.FC<ProductosProps> = ({
  getProducts,
  postProducts,
  updateProduct,
  deleteProducto,
  deleteImagen,
  GetAllCategorys,
  getAllOfertasActivas,
  addItem,
  ofertas,
  productos,
  categorias,
  carritoItems,
  loading = false,
}) => {
  const history = useHistory();
  const location = useLocation();

  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<ProductosResponse | null>(null);
  const [productToEdit, setProductToEdit] = useState<ProductosResponse | null>(null);
  const [menuAbierto, setMenuAbierto] = useState<string | null>(null);
const [refreshing, setRefreshing] = useState(false);
const [searchText, setSearchText] = useState('');
const [selectedCategory, setSelectedCategory] = useState<string | undefined>(undefined);
const [availabilityFilter, setAvailabilityFilter] = useState<AvailabilityFilter>('todos');
const [sortBy, setSortBy] = useState<SortOption>('destacados');
const [visibleCount, setVisibleCount] = useState(PRODUCTOS_POR_CARGA);
const handleRefresh = async () => {
  setRefreshing(true);
  if (getProducts) getProducts();
  if (getAllOfertasActivas) getAllOfertasActivas();
  setTimeout(() => setRefreshing(false), 800);
};
  useEffect(() => {
    if (getProducts) getProducts();
    if (getAllOfertasActivas) getAllOfertasActivas();
    if (GetAllCategorys) GetAllCategorys();
  }, [getProducts]);

  // Modo "categoría fija": se llega con ?categoria=... (ej. desde "Combos / Rutinas" del navbar).
  // En ese caso se oculta el buscador/selector y solo se ven los productos de esa categoría.
  const categoriaParam = new URLSearchParams(location.search).get('categoria');
  const categoriaFija = !!categoriaParam;

  useEffect(() => {
    if (!categoriaParam) {
      setSelectedCategory(undefined);
      return;
    }
    if (!categorias || categorias.length === 0) return;
    const match = categorias.find(c => c.nombre.trim().toUpperCase() === categoriaParam.trim().toUpperCase());
    if (match) setSelectedCategory(match.nombre);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriaParam, categorias]);

  useEffect(() => {
    setVisibleCount(PRODUCTOS_POR_CARGA);
  }, [searchText, selectedCategory, availabilityFilter, sortBy, categoriaParam]);

  const handleCreate = (data: ProductosRequest) => {
    if (postProducts) {
      postProducts(data);
      setShowModal(false);
      setTimeout(() => { if (getProducts) getProducts(); }, 500);
    }
  };

  const handleUpdate = (data: UpdateProductsRequest) => {
    if (updateProduct) {
      updateProduct(data);
      setProductToEdit(null);
      setTimeout(() => { if (getProducts) getProducts(); }, 500);
    }
  };

  const handleDeleteImage = (url: string) => {
    if (deleteImagen) deleteImagen(url);
  };

  const handleDelete = (producto: ProductosResponse) => {
    setMenuAbierto(null);
    if (!window.confirm(`¿Eliminar "${producto.nombre}" por completo? Esta acción no se puede deshacer.`)) return;
    if (deleteProducto) {
      deleteProducto(producto.id);
      setTimeout(() => { if (getProducts) getProducts(); }, 500);
    }
  };

  useEffect(() => {
    if (!menuAbierto) return;
    const closeMenu = () => setMenuAbierto(null);
    document.addEventListener('click', closeMenu);
    return () => document.removeEventListener('click', closeMenu);
  }, [menuAbierto]);

  const handleAddToCart = (producto: ProductosResponse, precioFinal: number) => {
    if (!addItem) return;
    addItem({
      productoId: producto.id,
      nombre: producto.nombre as string,
      precio: precioFinal,
      precioOriginal: producto.price,
      imagen: producto.imagenes && producto.imagenes.length > 0 ? producto.imagenes[0] : null,
      cantidad: 1,
      stockDisponible: producto.stock ?? 0,
    });
  };
  const filtrosActivos = Boolean(
    searchText.trim() || (!categoriaFija && selectedCategory) || availabilityFilter !== 'todos' || sortBy !== 'destacados'
  );

  // Los filtros se aplican sobre los productos ya cargados; no requieren cambios en la API.
  const productosFiltrados = [...(productos ?? [])]
    .filter(p => {
      const statusOk = isAdmin() ? true : p.status !== 'No Disponible' && p.status !== 'DISCONTINUED';
      const categoryOk = !selectedCategory || p.category?.trim().toUpperCase() === selectedCategory.trim().toUpperCase();
      const searchOk = !searchText.trim() || (p.nombre as string)?.toLowerCase().includes(searchText.trim().toLowerCase());
      const stock = p.stock ?? 0;
      const availabilityOk =
        availabilityFilter === 'todos' ||
        (availabilityFilter === 'disponibles' && stock > STOCK_BAJO_UMBRAL) ||
        (availabilityFilter === 'bajo' && stock > 0 && stock <= STOCK_BAJO_UMBRAL) ||
        (availabilityFilter === 'agotados' && stock === 0);

      return statusOk && categoryOk && searchOk && availabilityOk;
    })
    .sort((a, b) => {
      if (sortBy === 'precioAsc') return a.price - b.price;
      if (sortBy === 'precioDesc') return b.price - a.price;
      if (sortBy === 'nombre') return (a.nombre ?? '').localeCompare(b.nombre ?? '', 'es', { sensitivity: 'base' });
      return 0;
    });

  const limpiarFiltros = () => {
    setSearchText('');
    setSelectedCategory(categoriaFija ? selectedCategory : undefined);
    setAvailabilityFilter('todos');
    setSortBy('destacados');
  };
  const productosVisibles = productosFiltrados.slice(0, visibleCount);
  const hayMasProductos = productosFiltrados.length > visibleCount;
  return (
    <div className={styles.productos}>

      {/* Encabezado */}
      <div className={styles.productos__header}>
        <h1 className={styles.productos__title}>{categoriaFija ? 'Combos / Rutinas' : 'Productos'}</h1>
        <div style={{ display: 'flex', gap: 10 }}>   {/* wrapper nuevo */}
    <button
      className={`${styles.productos__createBtn} ${styles['productos__createBtn--outline']}`}
      onClick={handleRefresh}
    >
      <ReloadOutlined spin={refreshing} />
      Recargar
    </button>
        
        {isAdmin() && (
          <button className={styles.productos__createBtn} onClick={() => setShowModal(true)}>
            <PlusOutlined />
            <span>Nuevo Producto</span>
          </button>
        )}
      </div>
      </div>
      <div className={styles.productos__filters}>
          <Search
            placeholder="Buscar producto..."
            allowClear
            className={styles.productos__search}
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onSearch={val => setSearchText(val)}
          />
          {!categoriaFija && (
            <Select
              placeholder="Todas las categorías"
              allowClear
              className={styles.productos__select}
              onChange={(val) => setSelectedCategory(val)}
              value={selectedCategory}
              getPopupContainer={trigger => trigger.parentElement!}
            >
              {(categorias ?? []).map(cat => (
                <Option key={cat.id} value={cat.nombre}>{cat.nombre}</Option>
              ))}
            </Select>
          )}
          <Select
            className={styles.productos__select}
            value={availabilityFilter}
            onChange={(val: AvailabilityFilter) => setAvailabilityFilter(val)}
            getPopupContainer={trigger => trigger.parentElement!}
          >
            <Option value="todos">Toda disponibilidad</Option>
            <Option value="disponibles">Disponibles</Option>
            <Option value="bajo">Pocas unidades</Option>
            <Option value="agotados">Agotados</Option>
          </Select>
          <Select
            className={styles.productos__select}
            value={sortBy}
            onChange={(val: SortOption) => setSortBy(val)}
            getPopupContainer={trigger => trigger.parentElement!}
          >
            <Option value="destacados">Orden: destacados</Option>
            <Option value="precioAsc">Precio: menor a mayor</Option>
            <Option value="precioDesc">Precio: mayor a menor</Option>
            <Option value="nombre">Nombre: A-Z</Option>
          </Select>
          {filtrosActivos && (
            <button
              className={`${styles.productos__createBtn} ${styles['productos__createBtn--outline']} ${styles.productos__clearFilters}`}
              onClick={limpiarFiltros}
            >
              Limpiar filtros
            </button>
          )}
        </div>

      <div className={styles.productos__resultsBar}>
        <span>
          {productosFiltrados.length} {productosFiltrados.length === 1 ? 'producto encontrado' : 'productos encontrados'}
        </span>
        {filtrosActivos && <span className={styles.productos__resultsHint}>Filtros aplicados</span>}
      </div>

      {/* Grid de productos */}
      <div className={styles.productos__grid}>
        {loading && !(productos ?? []).length ? (
          Array.from({ length: 8 }).map((_, index) => (
            <div key={`skeleton-${index}`} className={styles.productos__skeletonCard} aria-hidden="true">
              <div className={styles.productos__skeletonImage} />
              <div className={styles.productos__skeletonBody}>
                <div className={`${styles.productos__skeletonLine} ${styles['productos__skeletonLine--title']}`} />
                <div className={`${styles.productos__skeletonLine} ${styles['productos__skeletonLine--short']}`} />
                <div className={styles.productos__skeletonLine} />
                <div className={`${styles.productos__skeletonLine} ${styles['productos__skeletonLine--button']}`} />
              </div>
            </div>
          ))
        ) : productosFiltrados.length > 0 ? (
  productosVisibles.map((producto) => {
            const oferta = getOfertaParaProducto(producto.id, null, ofertas ?? []);
            const { precioFinal, badge } = oferta
              ? calcularPrecioFinal(producto.price, oferta)
              : { precioFinal: producto.price, badge: '' };
            const sinStock = (producto.stock ?? 0) === 0;
            const stockBajo = !sinStock && (producto.stock ?? 0) <= STOCK_BAJO_UMBRAL;
            const enCarrito = (carritoItems ?? []).find(i => i.productoId === producto.id);
            const alcanzoStockMaximo = !!enCarrito && enCarrito.cantidad >= (producto.stock ?? 0);

            return (
            <div
              key={producto.id}
              className={`${styles.productos__card} ${sinStock ? styles['productos__card--outOfStock'] : ''}`}
            >
              {/* Imagen */}
              <div className={styles.productos__images}>
                {producto.imagenes && producto.imagenes.length > 0 ? (
                  <ImageCarousel imagenes={producto.imagenes} nombre={producto.nombre as string} />
                ) : (
                  <div className={styles.productos__noImage}>Sin imagen</div>
                )}
                {(producto.stock ?? 0) === 0 && (
                  <div className={styles.productos__agotadoBadge}>Agotado</div>
                )}

                {/* Menú editar/eliminar solo para admin — sobre la imagen */}
                {isAdmin() && (
                  <div className={styles.productos__actionsMenu} onClick={e => e.stopPropagation()}>
                    <button
                      className={styles.productos__editBtn}
                      onClick={() => setMenuAbierto(menuAbierto === producto.id ? null : producto.id)}
                      title="Opciones del producto"
                    >
                      <MoreOutlined />
                    </button>
                    {menuAbierto === producto.id && (
                      <div className={styles.productos__dropdown}>
                        <button
                          className={styles.productos__dropdownItem}
                          onClick={() => { setMenuAbierto(null); setProductToEdit(producto); }}
                        >
                          <EditOutlined /> Editar
                        </button>
                        <button
                          className={`${styles.productos__dropdownItem} ${styles['productos__dropdownItem--danger']}`}
                          onClick={() => handleDelete(producto)}
                        >
                          <DeleteOutlined /> Eliminar
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Info */}
              <div className={styles.productos__info}>
                <h3 className={styles.productos__name}>{producto.nombre}</h3>
                <p className={styles.productos__category}>{producto.category}</p>
                {/* <div
                  className={styles.productos__description}
                  dangerouslySetInnerHTML={{ __html: producto.description ?? '' }}
                /> */}
                {producto.description && (
                  <button
                    className={styles.productos__verMas}
                    onClick={() => history.push(`/products/${producto.id}`)}
                  >
                    Ver más
                  </button>
                  //  <button
                  //   className={styles.productos__verMas}
                  //   onClick={() => setSelectedProduct(producto)}
                  // >
                  //   Ver más
                  // </button>
                )}

              <div className={styles.productos__footer}>
                <div className={styles.productos__priceBlock}>
                  {badge && (
                    <span className={styles.productos__ofertaBadge}>{badge}</span>
                  )}
                  {oferta && (
                    <span className={styles.productos__precioOriginal}>
                      ${producto.price.toFixed(2)}
                    </span>
                  )}
                  <span className={styles.productos__price}>
                    ${precioFinal.toFixed(2)}
                  </span>
                </div>

                {!sinStock ? (
                  <span className={`${styles.productos__stock} ${stockBajo ? styles['productos__stock--low'] : ''}`}>
                    {stockBajo ? `Pocas unidades: ${producto.stock}` : `Stock: ${producto.stock}`}
                  </span>
                ) : (
                  <span className={`${styles.productos__stock} ${styles['productos__stock--out']}`}>Agotado</span>
                )}
              </div>

              <button
                className={styles.productos__addCartBtn}
                disabled={sinStock || alcanzoStockMaximo}
                onClick={() => handleAddToCart(producto, precioFinal)}
              >
                <ShoppingCartOutlined />
                {sinStock ? 'Agotado' : alcanzoStockMaximo ? 'Sin más stock' : 'Añadir al carrito'}
              </button>
              </div>
            </div>
            );
          })
        ) : (
          <div className={styles.productos__empty}>
            <strong>No encontramos productos</strong>
            <span>{filtrosActivos ? 'Prueba cambiando o limpiando los filtros.' : 'Aún no hay productos publicados.'}</span>
            {filtrosActivos && (
              <button
                className={`${styles.productos__createBtn} ${styles['productos__createBtn--outline']}`}
                onClick={limpiarFiltros}
              >
                Ver todos los productos
              </button>
            )}
          </div>
        )}
      </div>

      {hayMasProductos && (
        <div className={styles.productos__loadMoreWrap}>
          <button
            type="button"
            className={`${styles.productos__createBtn} ${styles['productos__createBtn--outline']} ${styles.productos__loadMore}`}
            onClick={() => setVisibleCount(count => count + PRODUCTOS_POR_CARGA)}
          >
            Mostrar más
            <span>{Math.min(PRODUCTOS_POR_CARGA, productosFiltrados.length - visibleCount)} restantes</span>
          </button>
        </div>
      )}

      {/* Modal crear producto */}
      {showModal && (
        <CreateProductModal
          onClose={() => setShowModal(false)}
          onSubmit={handleCreate}
          GetAllCategorys={GetAllCategorys}
          categorias={categorias}
        />
      )}

      {/* Modal detalle producto */}
      {selectedProduct && (
        <ProductDetailModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}

      {/* Modal actualizar producto */}
      {productToEdit && (
        <UpdateProductModal
          product={productToEdit}
          onClose={() => setProductToEdit(null)}
          onSubmit={handleUpdate}
          onDeleteImage={handleDeleteImage}
          GetAllCategorys={GetAllCategorys}
          categorias={categorias}
        />
      )}

    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  productos: state.productosAction.products,
  categorias: state.categoryAction.categories,
  ofertas: state.ofertasAction.ofertas,
  carritoItems: state.carritoAction.items,
  loading: state.system.showLoading,
});

export default connect(mapStateToProps, { getProducts, postProducts, updateProduct, deleteProducto, deleteImagen, GetAllCategorys,
   getAllOfertasActivas, addItem })(Productos);
